export const ACCOUNT_PAGE = { label: 'Espace Mon Compte', to: '/account', allowedRoles: ['ROLE_CLIENT'] };

export const pages = [
  { label: 'Catalogue Produits', to: '/catalog', allowedRoles: ['ROLE_CLIENT'] },
  { label: 'Gestion des utilisateurs', to: '/users', allowedRoles: ['ROLE_ADMIN'] },
  { label: 'Gestion des annonces', to: '/announcements', allowedRoles: ['ROLE_ADMIN'] },
];
